import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ metric }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-all duration-250">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-primary/10">
          <Icon name={metric?.icon} size={24} className="text-primary" />
        </div>
      </div>
      <div className="text-3xl font-bold text-foreground mb-2">
        {metric?.value}
      </div>
      <div className="text-sm text-muted-foreground font-caption mb-3">
        {metric?.label}
      </div>
      {metric?.change && (
        <div
          className={`flex items-center gap-1 text-xs font-medium ${
            metric?.changeType === 'increase' ?'text-success'
              : metric?.changeType === 'warning' ?'text-warning' :'text-muted-foreground'
          }`}
        >
          <Icon
            name={
              metric?.changeType === 'increase' ?'TrendingUp'
                : metric?.changeType === 'warning' ?'AlertCircle' :'Minus'
            }
            size={14}
          />
          <span>{metric?.change}</span>
        </div>
      )}
    </div>
  );
};

export default MetricsCard;